<div *ngIf="loading?.loadingStatus">
    <div class="spinner-container col-sm-12" data-testid="spinner">
      <div class="spinner-border" role="status">
      </div>
      <span class="loading-message">Cargando</span>
    </div>
</div>
